import { useEffect, useState } from "react";
import timezone from "dayjs/plugin/timezone";
import { Box, Divider, TextField, Typography, useTheme } from "@mui/material";
import MenuItemMui from "@mui/material/MenuItem";
import { tokens } from "../../theme";
import dayjs, { utc } from "dayjs";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.tz.setDefault("Asia/Colombo");
const CementBlocksDetails = ({ mainData, setMainData, isNonMobile }) => {
  const [rows, setRows] = useState([]);
  const [samplingCount, setSamplingCount] = useState(0);
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  // Initial row data structure
  const initialRow = {
    count: samplingCount,
    mdd: "", //lengthaveragebottom
    omc: "", //widthaveragebottom
    dd: "", //areaofbottom
    mc: "", //length averagetop
    degreeOfCompaction: "", //widthaveratetop
    layerThickness: "", //effective area of cube
    cum: "", //load
    compressiveStrength: "",
  };

  // SOLID,HOLLOW
  const reportTypeArray = [
    {
      value: "SOLID",
      label: "SOLID",
    },
    {
      value: "HOLLOW",
      label: "HOLLOW",
    },
    {
      value: "CELLUAR",
      label: "CELLUAR",
    },
  ];

  const nominalSize = [
    {
      value: "390mm x 100mm x 190mm",
      label: "390mm x 100mm x 190mm",
    },
    {
      value: "390mm x 190mm x 100mm",
      label: "390mm x 190mm x 100mm",
    },
    {
      value: "390mm x 190mm x 150mm",
      label: "390mm x 190mm x 150mm",
    },
    {
      value: "390mm x 200mm x 190mm",
      label: "390mm x 200mm x 190mm",
    },
    {
      value: "390mm x 150mm x 190mm",
      label: "390mm x 150mm x 190mm",
    },

    {
      value: "390mm x 190mm x 200mm",
      label: "390mm x 190mm x 200mm",
    },
    {
      value: "400mm x 100mm x 200mm",
      label: "400mm x 100mm x 200mm",
    },
    {
      value: "400mm x 150mm x 200mm",
      label: "400mm x 150mm x 200mm",
    },
    {
      value: "400mm x 200mm x 200mm",
      label: "400mm x 200mm x 200mm",
    },
  ];

  const mixOfConcrete = [
    {
      value: "Not intimated",
      label: "Not intimated",
    },
  ];

  const physicalAppearance = [
    {
      value: "Satisfactory",
      label: "Satisfactory",
    },
    {
      value: "Not satisfactory",
      label: "Not satisfactory",
    },

    {
      value: "Fair",
      label: "Fair",
    },
  ];

  useEffect(() => {
    setMainData((pre) => ({
      ...pre,
      labTestsDataFromSubs: rows,
    }));
  }, [rows]);

  // Add new row
  const addRow = () => {
    const newCount =
      mainData.labTestsDataFromSubs.length > 0
        ? Math.max(...mainData.labTestsDataFromSubs.map((row) => row.count)) + 1
        : 1;
    setSamplingCount(newCount);
    setRows([
      ...mainData.labTestsDataFromSubs,
      { ...initialRow, count: newCount },
    ]);
  };
  // Handle input changes
  const handleInputChange = (count, field, value) => {
    const updatedRows = mainData.labTestsDataFromSubs.map((row) => {
      if (row.serialNo === count) {
        const updatedRow = { ...row, [field]: value };

        // if (field === "dd" || field === "mdd") {
        //   const ddValue = field === "dd" ? value : updatedRow.dd;
        //   const mddValue = field === "mdd" ? value : updatedRow.mdd;

        //   // Calculate only if both values are valid numbers
        //   if (ddValue && mddValue && !isNaN(ddValue) && !isNaN(mddValue)) {
        //     const degreeOfCompaction =
        //       (parseFloat(ddValue) / parseFloat(mddValue)) * 100;
        //     updatedRow.degreeOfCompaction = degreeOfCompaction.toFixed(2);
        //   } else {
        //     updatedRow.degreeOfCompaction = "";
        //   }
        // }
        return updatedRow;
      }
      return row;
    });

    setRows(updatedRows);
  };

  return (
    <Box>
      <Box>
        <Box display="flex" flexDirection="column">
          <Box display="flex" flexDirection="row" gap={1}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DemoContainer
                components={["DatePicker"]}
                sx={{
                  paddingTop: "8px",
                  paddingBottom: "8px",
                }}
              >
                <DatePicker
                  label="Date of cast"
                  size="small"
                  format="YYYY-MM-DD"
                  timezone="Asia/Colombo"
                  value={
                    mainData.dateOfCast
                      ? dayjs(mainData.dateOfCast).tz("Asia/Colombo", true)
                      : dayjs(new Date()).tz("Asia/Colombo", true)
                  }
                  onChange={(newValue) => {
                    const colomboTime = newValue?.tz("Asia/Colombo", true);
                    setMainData((pre) => ({
                      ...pre,
                      dateOfCast: dayjs(colomboTime).format("YYYY-MM-DD"),
                    }));
                  }}
                  slotProps={{
                    textField: {
                      variant: "outlined",
                      size: "small",
                    },
                  }}
                />
              </DemoContainer>
            </LocalizationProvider>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DemoContainer
                components={["DatePicker"]}
                sx={{
                  paddingTop: "8px",
                  paddingBottom: "8px",
                }}
              >
                <DatePicker
                  label="Date of test"
                  size="small"
                  format="YYYY-MM-DD"
                  timezone="Asia/Colombo"
                  value={
                    mainData.dateOfTest
                      ? dayjs(mainData.dateOfTest).tz("Asia/Colombo", true)
                      : dayjs(new Date()).tz("Asia/Colombo", true)
                  }
                  onChange={(newValue) => {
                    const colomboTime = newValue?.tz("Asia/Colombo", true);
                    setMainData((pre) => ({
                      ...pre,
                      dateOfTest: dayjs(colomboTime).format("YYYY-MM-DD"),
                    }));
                  }}
                  slotProps={{
                    textField: {
                      variant: "outlined",
                      size: "small",
                    },
                  }}
                />
              </DemoContainer>
            </LocalizationProvider>
          </Box>
          <Box display="flex" flexDirection="row" gap={1}>
            <TextField
              select
              label="Type" //Grade on DB
              size="small"
              defaultValue=""
              value={mainData.grade}
              onChange={(e) => {
                setMainData((pre) => ({
                  ...pre,
                  grade: e.target.value,
                }));
              }}
              sx={{
                marginTop: "7px",
                marginBottom: "7px",
                width: "130px",
              }}
            >
              {reportTypeArray?.map((option) => (
                <MenuItemMui key={option.value} value={option.value}>
                  {option.label}
                </MenuItemMui>
              ))}
            </TextField>
            <TextField
              select
              label="Nominal size (L x W x H)" //cement in DB
              size="small"
              defaultValue=""
              value={mainData.cement}
              onChange={(e) => {
                setMainData((pre) => ({
                  ...pre,
                  cement: e.target.value,
                }));
              }}
              sx={{
                marginTop: "7px",
                marginBottom: "7px",
                width: "250px",
              }}
            >
              {nominalSize?.map((option) => (
                <MenuItemMui key={option.value} value={option.value}>
                  {option.label}
                </MenuItemMui>
              ))}
            </TextField>
            <TextField
              variant="outlined"
              sx={{ marginTop: "7px", width: "110px" }}
              type="text"
              label="Height(mm)"
              size="small"
              value={mainData.height}
              onChange={(e) => {
                setMainData((pre) => ({
                  ...pre,
                  height: e.target.value,
                }));
              }}
            />
            <TextField
              select
              label="Mix of concrete"
              size="small"
              defaultValue=""
              value={mainData.concreteMixture}
              onChange={(e) => {
                setMainData((pre) => ({
                  ...pre,
                  concreteMixture: e.target.value,
                }));
              }}
              sx={{
                marginTop: "7px",
                marginBottom: "7px",
                width: "140px",
              }}
            >
              {mixOfConcrete?.map((option) => (
                <MenuItemMui key={option.value} value={option.value}>
                  {option.label}
                </MenuItemMui>
              ))}
            </TextField>
            <TextField
              select
              label="Physical appearance"
              size="small"
              defaultValue=""
              value={mainData.interlockType}
              onChange={(e) => {
                setMainData((pre) => ({
                  ...pre,
                  interlockType: e.target.value,
                }));
              }}
              sx={{
                marginTop: "7px",
                marginBottom: "7px",
                width: "160px",
              }}
            >
              {physicalAppearance?.map((option) => (
                <MenuItemMui key={option.value} value={option.value}>
                  {option.label}
                </MenuItemMui>
              ))}
            </TextField>
          </Box>
        </Box>
        <Divider sx={{ margin: "5px 0 5px 0" }} />
        {mainData.labTestsDataFromSubs.map((row, index) => (
          <Box flexDirection="row" display="flex" gap={0.5} key={index}>
            <Typography
              variant="h6"
              textAlign="center"
              alignContent="center"
              sx={{ width: "450px", marginTop: "1px" }}
              borderRadius={1}
              border={1}
              color={colors.grey[700]}
              height="35px"
            >
              Serial No : {row.serialNo}
            </Typography>
            <TextField
              variant="outlined"
              sx={{ margin: "2px 0 5px 0" }}
              type="text"
              label="Length average bottom(mm)"
              size="small"
              value={row.mdd}
              fullWidth
              onChange={(e) =>
                handleInputChange(row.serialNo, "mdd", e.target.value)
              }
            />
            <TextField
              variant="outlined"
              sx={{ margin: "2px 0 5px 0" }}
              type="text"
              label="Width average bottom"
              size="small"
              value={row.omc}
              fullWidth
              onChange={(e) =>
                handleInputChange(row.serialNo, "omc", e.target.value)
              }
            />
            <TextField
              variant="outlined"
              sx={{ margin: "2px 0 5px 0" }}
              type="text"
              label="Area of bottom in (mm²)"
              size="small"
              value={row.dd}
              fullWidth
              onChange={(e) =>
                handleInputChange(row.serialNo, "dd", e.target.value)
              }
            />
          </Box>
        ))}
      </Box>
      <Divider sx={{ margin: "5px 0 5px 0" }} />
      {/* -----------------------------------------------------------------enter values---------------------------------- */}
      <Box>
        {mainData.labTestsDataFromSubs.map((row, index) => (
          <Box key={index}>
            <Box
              display="grid"
              gap={0.5}
              padding="2px"
              gridTemplateColumns="repeat(6, minmax(0, 1fr))"
              sx={{
                "& > div": {
                  gridColumn: isNonMobile ? undefined : "span 6",
                },
              }}
            >
              <Typography
                variant="h6"
                textAlign="center"
                alignContent="center"
                sx={{ gridColumn: "span 1", marginTop: "5px" }}
                borderRadius={1}
                border={1}
                color={colors.grey[700]}
              >
                Serian No : {row.serialNo}
              </Typography>

              <TextField
                variant="outlined"
                type="number"
                label="Length average top (mm)"
                size="small"
                value={row.mc}
                onChange={(e) =>
                  handleInputChange(row.serialNo, "mc", e.target.value)
                }
                sx={{
                  gridColumn: "span 1",
                  "& .MuiInputBase-input": {
                    textAlign: "center",
                  },
                  marginTop: "5px",
                }}
              />
              <TextField
                variant="outlined"
                type="number"
                label="Width average top (mm)"
                size="small"
                value={row.degreeOfCompaction}
                onChange={(e) =>
                  handleInputChange(
                    row.serialNo,
                    "degreeOfCompaction",
                    e.target.value,
                  )
                }
                sx={{
                  gridColumn: "span 1",
                  "& .MuiInputBase-input": {
                    textAlign: "center",
                  },
                  marginTop: "5px",
                }}
              />
              <TextField
                variant="outlined"
                type="number"
                label="Effective area of cube (mm)"
                size="small"
                value={row.layerThickness}
                onChange={(e) =>
                  handleInputChange(
                    row.serialNo,
                    "layerThickness",
                    e.target.value,
                  )
                }
                sx={{
                  gridColumn: "span 1",
                  "& .MuiInputBase-input": {
                    textAlign: "center",
                  },
                  marginTop: "5px",
                }}
              />
              <TextField
                variant="outlined"
                type="number"
                label="Load (N)"
                size="small"
                value={row.cum}
                onChange={(e) =>
                  handleInputChange(row.serialNo, "cum", e.target.value)
                }
                sx={{
                  gridColumn: "span 1",
                  "& .MuiInputBase-input": {
                    textAlign: "center",
                  },
                  marginTop: "5px",
                }}
              />
              <TextField
                variant="outlined"
                type="number"
                label="Compressive strength (N/mm²)"
                size="small"
                value={row.compressiveStrength}
                onChange={(e) =>
                  handleInputChange(
                    row.serialNo,
                    "compressiveStrength",
                    e.target.value,
                  )
                }
                sx={{
                  gridColumn: "span 1",
                  "& .MuiInputBase-input": {
                    textAlign: "center",
                  },
                  marginTop: "5px",
                }}
              />
            </Box>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default CementBlocksDetails;
